import { Controller, Control } from 'react-hook-form';
import { LocalizationProvider, DatePicker as DatePickerComponent } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';

interface Props {
  name: string;
  control: Control<any>;
  label?: string;
  size?: 'small' | 'medium';
  defaultValue?: Dayjs;
}

export default function DatePicker({ name, control, label, defaultValue, size = 'medium' }: Props) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue?.format('YYYY-MM-DD')}
        render={({ field }) => {
          const parsedDate = field.value ? dayjs(field.value, 'YYYY-MM-DD') : null;

          return (
            <DemoContainer components={['DatePicker']} sx={{ pt: 0 }}>
              <DatePickerComponent
                {...field}
                label={label}
                value={parsedDate}
                onChange={(newValue) => {
                  const formattedValue = newValue ? newValue.format('YYYY-MM-DD') : null;
                  field.onChange(formattedValue);
                }}
                slotProps={{ textField: { size: size } }}
                sx={{ width: { xs: '100px', md: '100%' }, backgroundColor: 'white' }}
              />
            </DemoContainer>
          );
        }}
      />
    </LocalizationProvider>
  );
}
